const forEach = async (
  array: Array<any>,
  callback: (row: any, index?: number, array?: Array<any>) => Promise<void>
): Promise<void> => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

export default forEach;
